import React from 'react'
import AddOffer from './AddOffer'
import { useParams } from 'react-router-dom'

const UpdateOffer = () => {
    const { offerId } = useParams()
    return (
        <AddOffer type='update' offerId={offerId} />
    )
}

export default UpdateOffer